import Immutable, { fromJS } from 'immutable';

import * as types from './actionTypes';

import { getErrorMessage } from '../utils';
import { locale } from '../Tools/reducers';
import * as systemTypes from '../System/actionTypes';
import { getSurveyMap, transformResult, getSurveysListFromV2, getSubmitResponseFromV2 } from './transform';

let newState;
let newSurveys;
let newSurvey;

const getSurvey = (surveyState, survey) => (surveyState ? surveyState.mergeDeep(fromJS(survey)) : fromJS(survey));

const Surveys = (state, action) => {
  try {
    switch (action.type) {
      // LOCALE
      case systemTypes.FETCH_USER_LANGUAGE: {
        return state.set('strings', locale(action?.data?.language, 'survey'));
      }

      // FETCH SURVEYS
      case types.FETCH_SURVEYS_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingSurveys'], true);
        return newState;
      }

      case types.FETCH_SURVEYS_SUCCESS: {
        newSurveys = Immutable.Map(getSurveyMap(getSurveysListFromV2(action.data)));
        newSurveys = newState.getIn(['map']) ? newSurveys.mergeDeep(state.getIn(['map'])) : newSurveys;
        newState = newState.setIn(['map'], newSurveys);
        newState = newState.setIn(['loading', 'isLoadingSurveys'], false);
        return Immutable.fromJS(newState);
      }

      case types.FETCH_SURVEYS_FAIL: {
        newState = state.setIn(['loading', 'isLoadingSurveys'], false);
        newState = newState.setIn(['alerts', 'errors'], getErrorMessage(action));
        return newState;
      }

      // FETCH SURVEY
      case types.FETCH_SURVEY_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingSurvey'], true);
        return newState;
      }

      case types.FETCH_SURVEY_SUCCESS: {
        // set/update survey in store
        newSurvey = getSurvey(state.getIn(['map', action.id]), action.data);
        newState = state.setIn(['map', action.id], newSurvey);
        newState = newState.setIn(['loading', 'isLoadingSurvey'], false);
        return newState;
      }

      case types.FETCH_SURVEY_FAIL: {
        newState = newState.setIn(['loading', 'isLoadingSurvey'], false);
        newState = newState.setIn(['alerts', 'errors'], getErrorMessage(action));
        return newState;
      }

      // SUBMIT SURVEY FORM
      case types.SUBMIT_SURVEY_FORM_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingSurveyForm'], true);
        return newState;
      }

      case types.SUBMIT_SURVEY_FORM_SUCCESS: {
        // set/update survey in store
        newSurvey = transformResult(getSubmitResponseFromV2(action.data, action.commercialProducts));
        newSurvey = getSurvey(state.getIn(['map', action.id]), newSurvey);
        newState = state.setIn(['map', String(action.id)], newSurvey);
        newState = newState.setIn(['loading', 'isLoadingSurveyForm'], false);
        return newState;
      }

      case types.SUBMIT_SURVEY_FORM_FAIL: {
        newState = state.setIn(['loading', 'isLoadingSurveyForm'], false);
        newState = newState.setIn(['alerts', 'errors'], getErrorMessage(action));
        return newState;
      }

      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack);
    return state;
  }
};
export default Surveys;
